import Register from "./pages/Register";
import SuccessPage from "./pages/SuccessPage"; // if you created this
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

function App() {
  return (
<Router basename="/race/rex">
    
    <Routes>
        <Route path="/" element={<Register />} />
        <Route path="/success" element={<SuccessPage />} />
      </Routes>
    </Router>
  );
}

export default App;
